import { Stack } from "@mui/material";
import React from "react";

const SpacedTexts = ({
  firstText,
  secondText,
  direction,
  justify,
  gap,
  padding,
  textAlign,
  fullWidth,
  enableAlignItems,
}) => {
  return (
    <React.Fragment>
      <Stack
        direction={direction || "row"}
        justifyContent={justify || "space-between"}
        gap={gap || ""}
        padding={padding || ""}
        width={fullWidth && "100%"}
      >
        <Stack
          alignItems={enableAlignItems && textAlign}
          width={fullWidth && "100%"}
        >
          <p style={{ textAlign: textAlign || "initial" }}>{firstText}</p>
        </Stack>
        <Stack
          alignItems={enableAlignItems && textAlign}
          width={fullWidth && "100%"}
        >
          <p style={{ textAlign: textAlign || "initial" }}>{secondText}</p>
        </Stack>
      </Stack>
    </React.Fragment>
  );
};

export default SpacedTexts;
